/* ============================================================================
   Tour do professor — BARRAMENTO DE ABERTURA
   ============================================================================
   O gatilho vive no header (layout/HeaderMenu.js) e o tour vive no layout
   (layout/Main.js). Precisam de um canal, e este é o canal: um pub/sub de
   memória, ~20 linhas, sem estado persistido.

   POR QUE NÃO REDUX. O `general` é persistido pelo redux-persist. Um "abrir o
   tour" que passasse por lá viraria, sem ninguém pedir, exatamente a flag de
   "já viu" que a decisão de produto descartou — gravada no localStorage do
   professor, e sujeita à mesma armadilha que config/inteligenciaEducacional.js
   documenta para o menu. Um emissor de memória não tem como persistir nada: se
   o professor recarregar a página no meio do tour, ele simplesmente acaba, que é
   o comportamento correto para um tour pedido sob demanda.
   ========================================================================== */

const ouvintes = new Set();

/**
 * Registra quem reage ao pedido de abrir o tour.
 * @returns {Function} cancela a inscrição (usar no componentWillUnmount)
 */
export function inscrever(ouvinte) {
  ouvintes.add(ouvinte);
  return () => ouvintes.delete(ouvinte);
}

/** Pede a abertura do tour. Chamado pelo ícone de ajuda no header. */
export function abrirTour() {
  ouvintes.forEach(ouvinte => ouvinte());
}
